import { DynamicDeliveryTag } from 'components/DynamicDeliveryTag';

import type { TourOrigin } from '../helpers';

// Origin marker placed next to a tour's name. Fixe = nothing (the default); a tour carrying dynamic
// deliveries (entirely or mixed with fixed ones) shows the shared dynamic-delivery bolt.
export const OriginIcon = ({ origin, size = 15 }: { origin: TourOrigin; size?: number }) => {
    if (origin === 'fixe') return null;
    return (
        <DynamicDeliveryTag
            isDynamic
            label={origin === 'mixte' ? 'Tournée mixte (fixe + dynamique)' : 'Tournée dynamique'}
            size={size}
        />
    );
};
